export default "__VITE_ASSET__BxEt32vS__"